import React, { useEffect, useState } from "react";
import Header from "../directives/header";
import Sidebar from "../directives/sidebar";
import Footer from "../directives/footer";
import config from "../coreFIles/config";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import {
  getTechnicalResourcesAction,
  createTechnicalResourceAction,
  updateTechnicalResourceAction,
  deleteTechnicalResourceAction,
  TechnicalResourceBlockUnBlockAction,
} from "../Action/action";

const emptyForm = {
  id: "",
  title: "",
  sort_order: "0",
  is_active: "1",
  file: "",
};

const Technical = () => {
  const loginData = !Cookies.get("loginSuccessfastenerwarehouseAdmin")
    ? []
    : JSON.parse(Cookies.get("loginSuccessfastenerwarehouseAdmin"));
  if (!loginData || loginData === "") {
    window.location.href = `${config.baseUrl}`;
  }
  if (loginData.role != config.role_admin) {
    window.location.href = `dashboard`;
  }

  const [list, setList] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [spinloader, setspinloader] = useState(1);
  const [saving, setSaving] = useState(0);

  useEffect(() => {
    getList();
  }, []);

  const getList = async () => {
    const res = await getTechnicalResourcesAction({});
    if (res.success) {
      setList(res.data || []);
    } else {
      setList([]);
    }
    setspinloader(0);
  };

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setForm((old) => ({ ...old, [name]: value }));
  };

  const fileHandler = (e) => {
    setForm((old) => ({ ...old, file: e.target.files?.[0] || "" }));
  };

  const resetForm = () => {
    setForm(emptyForm);
    const input = document.getElementById("technical_file");
    if (input) input.value = "";
  };

  const editRow = (item) => {
    setForm({
      id: item.id,
      title: item.title || "",
      sort_order: String(item.sort_order ?? 0),
      is_active: String(item.is_active ?? 1),
      file: "",
    });
    const input = document.getElementById("technical_file");
    if (input) input.value = "";
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const saveRow = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) {
      toast.error("Title is required.");
      return;
    }
    if (!form.id && !form.file) {
      toast.error("PDF file is required.");
      return;
    }
    setSaving(1);
    const payload = {
      title: form.title.trim(),
      sort_order: form.sort_order || 0,
      is_active: form.is_active,
    };
    if (form.id) payload.id = form.id;
    if (form.file) payload.file = form.file;

    const res = form.id
      ? await updateTechnicalResourceAction(payload)
      : await createTechnicalResourceAction(payload);
    setSaving(0);
    if (res.success) {
      toast.success(res.msg);
      resetForm();
      getList();
    } else {
      toast.error(res.msg || "Something went wrong.");
    }
  };

  const deleteRow = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Delete this technical PDF?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const res = await deleteTechnicalResourceAction({ id });
      if (res.success) {
        toast.success(res.msg);
        if (String(form.id) === String(id)) resetForm();
        getList();
      } else {
        toast.error(res.msg);
      }
    });
  };

  const handleStatus = async (id, is_active) => {
    Swal.fire({
      title: "Are you sure?",
      text:
        is_active === 0
          ? "Are you sure you want to hide this PDF on the website?"
          : "Are you sure you want to show this PDF on the website?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: is_active == 0 ? "Yes, hide it" : "Yes, show it",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const res = await TechnicalResourceBlockUnBlockAction({ id, is_active });
      if (res.success) {
        getList();
        toast.success(is_active == 0 ? "PDF hidden." : "PDF published.");
      } else {
        toast.error(res.msg);
      }
    });
  };

  return (
    <>
      <Sidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <Toaster />
        <Header />
        <div className="container-lg mb-4">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb my-0 ms-2">
              <li className="breadcrumb-item">
                <span>
                  <a className="homelink" href={`${config.baseUrl}dashboard`}>
                    Home
                  </a>
                </span>
              </li>
              <li className="breadcrumb-item active">
                <span>Technical PDFs</span>
              </li>
            </ol>
          </nav>
        </div>
        <div className="body flex-grow-1 px-3">
          <div className="container-lg">
            <div className="row">
              <div className="col-md-12">
                <div className="card mb-4">
                  <div className="card-header">
                    <span>{form.id ? "Edit Technical PDF" : "Add Technical PDF"}</span>
                  </div>
                  <div className="card-body inner-body">
                    <form className="row g-3" onSubmit={saveRow}>
                      <div className="col-md-6">
                        <label className="form-label" htmlFor="title">
                          Title
                        </label>
                        <input
                          className="form-control"
                          id="title"
                          name="title"
                          type="text"
                          placeholder="Enter title"
                          value={form.title}
                          onChange={inputHandler}
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label" htmlFor="sort_order">
                          Sort order
                        </label>
                        <input
                          className="form-control"
                          id="sort_order"
                          name="sort_order"
                          type="number"
                          value={form.sort_order}
                          onChange={inputHandler}
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label" htmlFor="is_active">
                          Status
                        </label>
                        <select
                          className="form-control"
                          id="is_active"
                          name="is_active"
                          value={form.is_active}
                          onChange={inputHandler}
                        >
                          <option value="1">Active</option>
                          <option value="0">Hidden</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label" htmlFor="technical_file">
                          PDF file {form.id ? "(leave blank to keep current)" : ""}
                        </label>
                        <input
                          className="form-control"
                          id="technical_file"
                          name="file"
                          type="file"
                          accept="application/pdf,.pdf"
                          onChange={fileHandler}
                        />
                      </div>
                      <div className="col-12 text-end">
                        {form.id ? (
                          <button type="button" className="btn btn-secondary me-2" onClick={resetForm}>
                            Cancel
                          </button>
                        ) : null}
                        <button className="btn btn-primary" type="submit" disabled={saving === 1}>
                          {saving === 1 ? "Processing..." : form.id ? "Update" : "Add PDF"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="card mb-4">
                  <div className="card-header">
                    <span>Technical PDFs</span>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table mb-0">
                        <thead className="table-light fw-semibold">
                          <tr className="align-middle table-heading">
                            <th>Sr.</th>
                            <th>Title</th>
                            <th>PDF</th>
                            <th>Sort</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {spinloader == 0 ? (
                            list.length > 0 ? (
                              list.map((item, index) => (
                                <tr key={item.id}>
                                  <td>{index + 1}</td>
                                  <td>{item.title}</td>
                                  <td>
                                    {item.file_url ? (
                                      <a
                                        href={`${config.imageUrl}/${item.file_url}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        View PDF
                                      </a>
                                    ) : (
                                      "—"
                                    )}
                                  </td>
                                  <td>{item.sort_order}</td>
                                  <td>
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={item.is_active === 1}
                                        onChange={() => handleStatus(item.id, item.is_active === 1 ? 0 : 1)}
                                      />
                                    </div>
                                  </td>
                                  <td className="td-action">
                                    <button type="button" className="btn btn-primary editbtn" onClick={() => editRow(item)}>
                                      <i className="far fa-edit"></i> Edit
                                    </button>
                                    &nbsp;&nbsp;
                                    <button type="button" className="btn btn-primary deletebtn" onClick={() => deleteRow(item.id)}>
                                      <i className="fa fa-trash"></i> Delete
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  No technical PDFs found.
                                </td>
                              </tr>
                            )
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                <img
                                  className="loaderImg search-loader"
                                  src={config.baseUrl + "images/loader.gif"}
                                  height={20}
                                  width={20}
                                  alt=""
                                />
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Technical;
